module.exports = __webpack_public_path__ + "static/media/16_Lakshit_R@3x.d2013e62.jpg";